import { render, staticRenderFns } from "./EditCustomerInfoDialog.vue?vue&type=template&id=a622e280"
import script from "./EditCustomerInfoDialog.vue?vue&type=script&lang=js"
export * from "./EditCustomerInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports